import React from "react";

export default function Overlay(props) {

  return (
    <div className="-z-10 bg-overlay bg-cover fixed w-screen h-screen top-0 left-0 pointer-events-none" >
    {/* <div className="bg-overlay bg-cover fixed w-screen h-screen top-0 left-0 z-50 mix-blend-multiply pointer-events-none" > */}

    </div>
  );
}
